"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireWildcard(require("react"));

var QuantityCell =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(QuantityCell, _PureComponent);

  function QuantityCell() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, QuantityCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(QuantityCell)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.delete = function () {
      var _this$props = _this.props,
          deleteQuantity = _this$props.deleteQuantity,
          index = _this$props.index;
      deleteQuantity(index);
    };

    return _this;
  }

  (0, _createClass2.default)(QuantityCell, [{
    key: "render",
    value: function render() {
      var quantity = this.props.quantity;
      return _react.default.createElement("td", {
        className: "pricing-cell header quantity"
      }, _react.default.createElement("div", null, _react.default.createElement("button", {
        className: "pricing-cell__button clickable small",
        onClick: this.delete
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "bin-1-f"
      })), _react.default.createElement("h6", null, quantity)));
    }
  }]);
  return QuantityCell;
}(_react.PureComponent);

exports.default = QuantityCell;